<template>
    <div class="site-lookup-container">
        <multiselect 
            v-model="selectedSite" 
            placeholder="Type to search" 
            label="name"
            track-by="id" 
            :multiple="options.multiple" 
            :searchable="options.searchable"
            :options="sites"
            :options-limit="options.limit"
            :disabled="disabled"
            :close-on-select="options.closeOnSelect"
            :clear-on-select="options.clearOnSelect"
            :show-labels="options.showLabels"
            :loading="selectIsLoading"
            :showNoOptions="false"
            @search-change="search"
            @input="$emit('input', selectedSite)">
            <template slot="option" slot-scope="props">
                <div slot="option__desc">
                    <div class="option__title">{{ props.option.name }}</div>
                    
                    <div class="select-option-sub-title m-t-xs">
                        {{ props.option.city }}, {{ props.option.state }}
                    </div>
                </div>
            </template>

            <span slot="noResult">No results found.</span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    
    export default {
        data: () => ({
            sites: [],
            selectedSite: [],
            selectIsLoading: false,
        }),
        methods: {
            search(query) {
                if (query.length < 2)
                    return;
                
                axios.post(`${this.routes.api_url}/v1.0/${this.type}s/search`, {
                    term: query,
                    limit: this.options.limit,
                    district_id: this.districtId,
                }).then(response => {
                    this.sites = response.data;
                }, error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Internal Error!',
                        html: `Failed to retrieve ${this.type}. If this issue persists please <a href="${this.routes.ngm_url}/contact/error-report" target="_blank">contact us</a>.`,
                        showConfirmButton: false,
                        toast: true,
                        position: 'bottom-right',
                        customClass: {
                            container: 'mr-4 mb-4',
                        },
                    });
                });
            },
        },
        watch: {
            value: {
                handler(newVal) {
                    this.selectedSite = newVal
                }
            }
        },
        props: {
            value: {
                required: false
            },
            options: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            },
            districtId: {
                type: Number,
                required: false
            },
        },
        components: {
            Multiselect,
        }
    }
</script>

<style scoped>
    .site-lookup-container >>> .multiselect__content-wrapper {
        min-width: 100%;
        width: fit-content; 
    }
</style>
